module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2021_en-a12d49c24de264e78031b5671cacd21e.jpg";